var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "volumec" }, [
    _c("a", {
      staticClass: "vol-toggle",
      class: { muted: _vm.value == 0 },
      attrs: { href: "" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.toggleMute($event)
        },
        mouseenter: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.showBar($event)
        },
        mouseleave: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.hideBar($event)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "volVal",
        staticClass: "vol-val",
        class: {
          low: _vm.value < 30,
          hi: _vm.value >= 30,
          visible: _vm.visible
        },
        on: {
          mousedown: function($event) {
            $event.preventDefault()
            return _vm.dragStart($event)
          },
          mouseenter: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.showBar($event)
          },
          mouseleave: function($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.hideBar($event)
          }
        }
      },
      [
        _c("em", { style: { width: _vm.value + "%" } }),
        _c("span", [_vm._v(_vm._s(_vm.value))])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }